import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {
    SimplePresentation,
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";

import {CollapsePresentation} from "../runnerpresentations/maingame/win/CollapsePresentation";
import {WinSummery} from "../runnerpresentations/maingame/win/WinSummery";
import {SanityCheckPresentation} from "../runnerpresentations/maingame/win/SanityCheckPresentation";
import {BrokeBankPresentation} from "../runnerpresentations/maingame/win/BrokeBankPresentation";
import {BS2} from "../BS2";
import {
    CollectScattersPresentationAvalanche
} from "../runnerpresentations/maingame/win/CollectScattersPresentationAvalanche";
import {LevelUpgradePresentation} from "../runnerpresentations/maingame/win/LevelUpgradePresentation";
import {FreesSpinOutro} from "../runnerpresentations/FreesSpinOutro";
import {SuperFreespinScatters} from "../runnerpresentations/maingame/win/SuperFreespinScatters";
import {DrainAndRemoveWinSymbols} from "../runnerpresentations/maingame/win/DrainAndRemoveWinSymbols";
import {LocalPresentation} from "../../core/winpresentation/LocalPresentation";
import {XSplitPresentation} from "../runnerpresentations/features/XSplitPresentation";
import {FreeSpinUtils} from "../utils/FreeSpinUtils";
import {BS2GameMode} from "../server/BS2GameMode";
import {BS2Statics} from "../config/BS2Statics";
import {BS2Sound} from "../config/sound/BS2Sound";

export class BS2WinPresentation implements FlowStatePresentation {
    private presentations: SimplePresentation[];


    constructor() {
        this.presentations = [
            new CollectScattersPresentationAvalanche(),
            new SuperFreespinScatters(),
            new XSplitPresentation(),
            new WinSummery(),
            new DrainAndRemoveWinSymbols(),
            new CollapsePresentation(),
            new LevelUpgradePresentation(),
            new CollapsePresentation(),
            new BrokeBankPresentation(),
            new SanityCheckPresentation(),
            new LocalPresentation((controller: SimplePresentationRunnerController) => this.updateFreespinsLeft(controller), () => {
                return true
            }, "updateFreespinsLeft"),
            new FreesSpinOutro(),
        ];
    }

    public start(flowStateController: FlowStateController) {
        SimplePresentationRunner.run(this.presentations, () => flowStateController.finish(), (callback?: Function) => flowStateController.setSkipCallback(callback), "WinRunner ");
    }

    private updateFreespinsLeft(controller: SimplePresentationRunnerController) {
        if (BS2.model.isNextFreeSpin() || BS2.model.isNextSuperFreespin()) {
            FreeSpinUtils.setKeypadSpinCounter(BS2.model.data.freespinsLeft);
            BS2.reelView.freespinCounter.showCount(BS2.model.data.freespinsLeft);
        } else if (BS2.model.isNextNormal()) {
            if (BS2.model.isFreeSpin()) {
                if(BS2.apiPlugin.betFeatureController.getActiveBetFeature()?.name===BS2Statics.BOOSTED_BET_1 && BS2.model.data.currentLevel===1){

                }
                else{
                    BS2.soundPlayer.stopLevel();
                    BS2.soundPlayer.switchMusic(BS2GameMode.NORMAL);
                }
            }
            BS2.keypadPlugin.setZeroBetSpinCounter(-1);
            BS2.reelView.freespinCounter.showCount(-1);
        }

        controller.finish();
    }
}